import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieVoiceSimulatorDefaults } from "@/types";

export function useGetSadieVoiceSimulatorDefaults() {
  return useQuery({
    queryKey: ["sadie-voice-simulator-defaults"],
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieVoiceSimulatorDefaults,
        HttpResponse<SadieVoiceSimulatorDefaults>
      >("relationships/simulate/voice/defaults");
      return res.data;
    },
    // Placeholders from code; they do not change under the page.
    staleTime: Infinity,
  });
}
